import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils/Assets';
import { CommonHexagonBadge } from '../common';
import { useSettings } from '@/providers';
const CardAddNew = ({
  path,
  size,
  iconSize,
  title,
  subTitle,
  onClick,
  icon = 'rocket',
}) => {
  const {
    getThemeMode
  } = useSettings();
  const cardClasses = 'w-full h-full card border-2 border-dashed border-brand-clarity bg-center bg-[length:600px] bg-no-repeat';
  const cardStyles = {
    backgroundImage: getThemeMode() === 'dark' ? `url('${toAbsoluteUrl('/media/images/2600x1200/bg-4-dark.png')}')` : `url('${toAbsoluteUrl('/media/images/2600x1200/bg-4.png')}')`
  };
  const content = <div className="card-body grid items-center">
      <div className="flex flex-col gap-3">
        <div className="flex justify-center pt-5">
          <CommonHexagonBadge size={size} badge={<KeenIcon icon={icon} className={`${iconSize} text-brand`} />} stroke="stroke-brand-clarity" fill="fill-light" />
        </div>

        <div className="flex flex-col text-center">
          <span className="text-lg font-medium text-gray-900 hover:text-primary-active mb-px">
            {title}
          </span>
          <span className="text-2sm text-gray-700">{subTitle}</span>
        </div>
      </div>
    </div>;
  return <Fragment>
      {onClick ? <button type="button" className={cardClasses} style={cardStyles} onClick={onClick}>
          {content}
        </button> : <Link to={`${path}`} className={cardClasses} style={cardStyles}>
          {content}
        </Link>}
    </Fragment>;
};

CardAddNew.propTypes = {
  path: PropTypes.string,
  size: PropTypes.string,
  iconSize: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  onClick: PropTypes.func
};

export { CardAddNew };
